import { BaseQueryInterceptor, commonAPI } from "./commonApi";
import {
  ICategoryGame,
  ICreateGameSession,
  ICreateSpSession,
  IFavorite,
  IGame,
  IGameSession,
  IGetGamesClearList,
  IGetGamesRequest,
  IGetTokenSport,
  IGetTvGamesRequest,
  IProviderGame,
  IsFavoriteGame,
} from "../types/gamesTypes";
import { createApi } from "@reduxjs/toolkit/query/react";

export const gamesAPI = createApi({
  reducerPath: "gamesApi",
  baseQuery: BaseQueryInterceptor,
  endpoints: (build) => ({
    getProviders: build.query<string[], void>({
      query: () => ({
        url: "/json-rpc/game-providers",
        method: "GET",
      }),
    }),
    getProvidersTv: build.query<string[], void>({
      query: () => ({
        url: "/json-rpc/tv-game-providers",
        method: "GET",
      }),
    }),
    getCategories: build.query<ICategoryGame[], void>({
      query: () => ({
        url: "/game-category",
        method: "GET",
      }),
    }),
    getGameInfo: build.mutation<IGame, string>({
      query: (id) => ({
        url: `/info/game/${id}`,
        method: "GET",
      }),
    }),
    getGames: build.mutation<IProviderGame[], IGetGamesRequest>({
      query: (obj: Record<any, any>) => ({
        url: `/json-rpc/game-list`,
        method: "GET",
        params: obj,
      }),
    }),
    getGameList: build.mutation<IGetGamesClearList, IGetGamesRequest>({
      query: (obj: Record<any, any>) => ({
        url: "/json-rpc/game-list-clear",
        method: "GET",
        params: obj.data,
      }),
    }),
    getTvGames: build.mutation<IProviderGame[], IGetTvGamesRequest>({
      query: (obj) => ({
        url: "/json-rpc/tv-game-list-by-provider",
        method: "GET",
        params: obj.data,
      }),
    }),
    getTvGamesList: build.mutation<IGetGamesClearList, IGetTvGamesRequest>({
      query: (obj) => ({
        url: "/json-rpc/tv-game-list",
        method: "GET",
        params: obj.data,
      }),
    }),
    getProviderGames: build.mutation<IProviderGame, IGetGamesRequest>({
      query: (obj: Record<any, any>) => ({
        url: `/json-rpc/${obj?.provider}/games`,
        method: "GET",
        // params: {title: obj.title, page: obj.page, size: obj.size}
        params: obj,
      }),
    }),
    getSportToken: build.mutation<IGetTokenSport, void>({
      query: () => ({
        url: "/json-rpc/create-session/sport",
        method: "GET",
      }),
    }),
    createSession: build.mutation<IGameSession, ICreateGameSession>({
      query: (obj) => ({
        url: "/json-rpc/create-session",
        method: "POST",
        body: obj,
      }),
    }),
    createBetbySession: build.mutation<{ token: string }, void>({
      query: () => ({
        url: "/json-rpc/create-session/betby",
        method: "GET",
      }),
    }),
    createMondoSession: build.mutation<
      { sessionUrl: string },
      { mode?: string; t?: "prematch" | "live" }
    >({
      query: (obj: Record<any, any>) => ({
        url: "/json-rpc/create-session/mondo",
        method: "GET",
        params: obj,
      }),
    }),
    createGaminghubSession: build.mutation<{ sessionUrl: string }, void>({
      query: () => ({
        url: "/json-rpc/create-session/gabsys",
        method: "GET",
      }),
    }),
    createSpSession: build.mutation<{ sessionUrl: ICreateSpSession }, void>({
      query: () => ({
        url: "/json-rpc/create-session/sp-sport",
        method: "GET",
      }),
    }),
    createDigitainSession: build.mutation<
      { SessionHTML: string },
      { isMobile: boolean, isLive?: boolean }
    >({
      query: (obj) => ({
        url: `/json-rpc/create-session/fundist`,
        method: "GET",
        params: obj,
      }),
    }),
    createSportSession: build.mutation<{ token: string }, void>({
      query: () => ({
        url: "/json-rpc/create-session/sport",
        method: "GET",
      }),
    }),
    createWalletSession: build.mutation<{ SessionUrl: string }, void>({
      query: () => ({
        url: "/json-rpc/create-session/wallet",
        method: "GET",
      }),
    }),
    toggleFavoriteGameSession: build.mutation<IsFavoriteGame, IFavorite>({
      query: (obj) => ({
        url: "/user/favorite-games",
        method: "PUT",
        body: obj,
      }),
    }),
  }),
});

export const {
  useGetProvidersQuery,
  useGetProvidersTvQuery,
  useGetCategoriesQuery,
  useGetGamesMutation,
  useGetGameListMutation,
  useGetTvGamesMutation,
  useGetTvGamesListMutation,
  useGetProviderGamesMutation,
  useToggleFavoriteGameSessionMutation,
  useCreateSessionMutation,
  useGetSportTokenMutation,
  useCreateBetbySessionMutation,
  useCreateMondoSessionMutation,
  useCreateGaminghubSessionMutation,
  useCreateSportSessionMutation,
  useCreateWalletSessionMutation,
  useGetGameInfoMutation,
  useCreateSpSessionMutation,
  useCreateDigitainSessionMutation,
} = gamesAPI;
